import React from 'react';
import { observer } from 'mobx-react-lite';
import styles from './simple-label.module.scss';

export type SimpleLabel = {
  title: string | JSX.Element;
};

type Props = {
  color?: 'primary' | 'default' | 'success';
  isBold?: boolean;
  smallText?: boolean;
  labels?: SimpleLabel[];
  baseKey?: string;
};

export const SimpleLabels = observer(({ color = 'default', isBold = true, smallText = false, labels, baseKey }: Props) => {
  return (
    <div className="d-inline-block">
      {labels &&
        labels?.map((simpleLabel: SimpleLabel, index: number) => (
          <span
            className={`${styles.simpleLabelElm} ${styles[color]} ${
              isBold ? styles.bold : ''
            } ${
              smallText ? styles.small : ''
            } rounded py-1 px-2 text-center`}
            key={`label_${baseKey}${index}`}
          >
            {simpleLabel.title}
          </span>
        ))}
    </div>
  );
});